module.exports = __webpack_public_path__ + "img/upload_noback.27efe51f.svg";